import { useState } from 'react';

export const ChipClear = () => {
  const [buttonHover, setButtonHover] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onMouseEnter={() => {
        setButtonHover(true);
      }}
      onMouseLeave={() => {
        setButtonHover(false);
      }}
    >
      {buttonHover && <rect width="20" height="20" rx="4" fill="#1E1E1E" fillOpacity="0.1" />}
      <mask
        id="mask0_13479_57"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13479_57)">
        <path
          d="M10 11.0625L6.58334 14.4792C6.43056 14.6319 6.25695 14.7049 6.06251 14.6979C5.86806 14.691 5.69445 14.6111 5.54167 14.4583C5.38889 14.3055 5.31251 14.1285 5.31251 13.9271C5.31251 13.7257 5.38889 13.5486 5.54167 13.3958L8.93751 9.99999L5.52084 6.58332C5.36806 6.43055 5.29514 6.25346 5.30209 6.05207C5.30903 5.85068 5.38889 5.6736 5.54167 5.52082C5.69445 5.36805 5.87153 5.29166 6.07292 5.29166C6.27431 5.29166 6.45139 5.36805 6.60417 5.52082L10 8.93749L13.4167 5.52082C13.5694 5.36805 13.7465 5.29166 13.9479 5.29166C14.1493 5.29166 14.3264 5.36805 14.4792 5.52082C14.6319 5.6736 14.7083 5.85068 14.7083 6.05207C14.7083 6.25346 14.6319 6.43055 14.4792 6.58332L11.0625 9.99999L14.4792 13.4167C14.6319 13.5694 14.7083 13.743 14.7083 13.9375C14.7083 14.1319 14.6319 14.3055 14.4792 14.4583C14.3264 14.6111 14.1493 14.6875 13.9479 14.6875C13.7465 14.6875 13.5694 14.6111 13.4167 14.4583L10 11.0625Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
